import axios from "axios";
import { API_PATHS } from "../../paths";
import SocialMediaUpdateItem from "../../Model/SocialMediaUpdateModel";
import { flashMessage } from "../../../utils/flashMessageService";

/**
 * GET /api/socialmediaupdates/:socialMediaId
 */
export async function fetchSocialMediaUpdatesBySocialMediaId(socialMediaId, payload = {}) {
  try {
    const res = await axios.get(API_PATHS.socialMediaUpdatesBySocialMediaId(socialMediaId), {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      params: payload,
    });
    const items = res.data || [];
    return items.map((i) => SocialMediaUpdateItem.fromJSON(i));
  } catch (error) {
    console.error("Error fetching social media updates:", error);
    flashMessage("fetchSocialMediaUpdates failed. Please try again.", { type: "error" });
    throw error;
  }
}

/**
 * GET /api/socialmediaupdates
 */
export async function fetchSocialMediaUpdates(payload = {}) {
  try {
    const res = await axios.get(API_PATHS.socialMediaUpdates, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      params: payload,
    });
    const items = res.data || [];
    return items.map((i) => SocialMediaUpdateItem.fromJSON(i));
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("fetchSocialMediaUpdates failed with status 400:", error.response.data);
      flashMessage(`fetchSocialMediaUpdates failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error fetching social media updates:", error);
      flashMessage("fetchSocialMediaUpdates failed. Please try again.", { type: "error" });
    }
    console.error("fetchSocialMediaUpdates error:", error);
    throw error;
  }
}

/**
 * POST /api/socialmediaupdates
 */
export async function createSocialMediaUpdate(payload = {}) {
  try {
    const isFormData = typeof FormData !== "undefined" && payload instanceof FormData;
    const body = isFormData
      ? payload
      : Object.entries(payload).reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null) acc[key] = value;
          return acc;
        }, {});

    const headers = {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    };

    if (isFormData) headers["Content-Type"] = "multipart/form-data";
    else headers["Content-Type"] = "application/json";

    const res = await axios.post(API_PATHS.socialMediaUpdates, body, { headers });
    flashMessage("Social media update created successfully.", { type: "success" });
    return SocialMediaUpdateItem.fromJSON(res.data);
  } catch (error) {
    console.error("Error creating social media update:", error);
    flashMessage("createSocialMediaUpdate failed. Please try again.", { type: "error" });
    throw error;
  }
}

/**
 * GET /api/socialmediaupdate/:id
 */
export async function fetchSocialMediaUpdateById(id) {
  try {
    const res = await axios.get(API_PATHS.socialMediaUpdateById(id), {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return SocialMediaUpdateItem.fromJSON(res.data);
  } catch (error) {
    console.error(`Error fetching social media update (${id}):`, error);
    flashMessage("fetchSocialMediaUpdateById failed. Please try again.", { type: "error" });
    throw error;
  }
}


/**
 * PUT /api/socialmediaupdates/:id
 */
export async function updateSocialMediaUpdate(id, payload = {}) {
  try {
    const isFormData = typeof FormData !== "undefined" && payload instanceof FormData;
    const body = isFormData
      ? payload
      : Object.entries(payload).reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null) acc[key] = value;
          return acc;
        }, {});

    const headers = {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    };

    if (isFormData) headers["Content-Type"] = "multipart/form-data";
    else headers["Content-Type"] = "application/json";

    const res = await axios.put(API_PATHS.socialMediaUpdateById(id), body, { headers });
    flashMessage("Social media update saved successfully.", { type: "success" });
    return SocialMediaUpdateItem.fromJSON(res.data);
  } catch (error) {
    console.error(`Error updating social media update (${id}):`, error);
    flashMessage("updateSocialMediaUpdate failed. Please try again.", { type: "error" });
    throw error;
  }
}



/**
 * DELETE /api/socialmediaupdate/:id
 */
export async function deleteSocialMediaUpdate(id) {
  try {
    const res = await axios.delete(API_PATHS.socialMediaUpdateById(id), {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    flashMessage("Social media update deleted successfully.", { type: "success" });
    return res.data;
  } catch (error) {
    console.error(`Error deleting social media update (${id}):`, error);
    flashMessage("deleteSocialMediaUpdate failed. Please try again.", { type: "error" });
    throw error;
  }
}
